module.exports = __webpack_public_path__ + "1ff6bc0ab188f50c10fde9e6e4a6d849.png";